import { AnswerGiven } from './AnswerGiven';
import { INPUT } from './data/constants';

import { Prompt } from './prompt';
export class Question{
    prompts:Prompt[]=[]
    questionText =""
    isMediaPresent=false
    server_question_id=0
    imageListQuestionBody=[]
    //is_radio_group=false
    //is_input= false
    questionPresentation=INPUT
    is_multipart=0
    correctAnswer = new AnswerGiven()

    myExplanations=[]
    myConcepts=[]
    htmlExplanation=""
    answerDescriptionVersion=0
    answerGiven=new AnswerGiven()
    choices=[]
    questionIndex=0
    template_detail:string
    template:string
}
